import { defineStore } from "pinia";
import { isSupportPlay } from "@js/utils";
import { yunpb } from "@/types/protobuf";
// import { } from '@api'

export const useLayoutDataStore = defineStore("layoutData", {
  state: () => ({
    friendlyLinkData: [] as any[],
    helpData: [] as any[],
    // 浏览器不兼容弹窗
    downlaodBrowserModal: !isSupportPlay,
    // 绑定手机的弹窗
    bindModal: false,
    // 新用户赠送的弹窗
    newUserGiftModal: false,
    // 老用户赠送的弹窗 废弃
    oldUserGiftModal: false,
    // 扫描充值的弹窗
    chargeModal: false,
    // 没有游戏时长的弹窗
    noTimeModal: false,
    // 实名认证提示弹窗
    certTipsModal: true,
    // 已购游戏列表弹窗
    purchasedGameModal: false,
    purchasedGamesData: [] as yunpb.IPurchasedGame[],
    activePurchasedGames: {} as yunpb.IPurchasedGame,
    showPurchaseCompleted: false, // 已购买游戏的支付完成弹窗
    goodsGameType: null, // 购买的账号类型 cdkey 账号
    webVersionUpdateModal: false, // 更新内容弹窗
  }),
  actions: {
    updateStateProp(key: string, keyValue: any) {
      this[key] = keyValue;
    },
    // 获取友情链接数据
    async getFriendlyLink(payload = { key: "web_friendship_link" }) {
      if (this.friendlyLinkData.length === 0) {
        const apiData = [""];
        this.friendlyLinkData = [...apiData];
      }
    },
    // 获取帮助问答数据
    async getHelpData(payload = { key: "web_help_center" }) {
      if (this.helpData.length === 0) {
        const apiData = [""];
        this.helpData = [...apiData];
      }
    },
    async changeBindModal(isShow: boolean) {
      this.bindModal = isShow;
    },
  },
});
